module.exports = __webpack_public_path__ + "img/step1.e61f114e.png";